// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--fSKHK","link":"dece2e673c--link--W4jhE","link-area":"dece2e673c--link-area--oxWI7"};